import { client } from "../../client";
import { ContactType, Address } from "..";

export interface AccountContactsResult {
  results: AccountContact[];
}

export const BILL_DELIVERY = ["Post", "Email"] as const;
export type BillDelivery = typeof BILL_DELIVERY[number];

export const COMM_DELIVERY = ["Post", "Email", "SMS"] as const;
export type CommDelivery = typeof COMM_DELIVERY[number];

export type AccountContact = {
  id: string;
  forename: string | null;
  surname: string | null;
  title: string | null; // The job title of the contact
  isPrimary: boolean;
  type: ContactType;
  number1: string | null; // First phone number
  number2: string | null; // Second phone number
  number3: string | null; // Third phone number
  email: string | null; // Email address
  dateOfBirthDt: string | null;
  address: Address;
  billDelivery: BillDelivery[];
  commDelivery: CommDelivery[];
  securityNumber: string | null;
};

export const getAccountContacts = (queryKey: string, accountNumber: string) => {
  return client
    .get<AccountContactsResult>(`accounts/${accountNumber}/contacts`)
    .then((response) => response?.data?.results);
};

export const editAccountContacts = ({
  accountNumber,
  values,
}: {
  accountNumber: string;
  values: Record<string, any>;
}) => {
  return client.put(`accounts/${accountNumber}/contacts`, values);
};
